// ServiceTitan Enterprise Hub host for each location, e.g. sarasota107.
const SERVICE_TITAN_HOST = {
  L101: 'orlandonorth101',
  L102: 'orlandosouth102',
  L103: 'orlandowest103',
  L105: 'jacksonville105',
  L106: 'tampa106',
  L107: 'sarasota107',
  L109: 'verobeach109',
  L110: 'volusiacounty110',
};

export const serviceTitanJobUrl = (tenantCode, jobId) => {
  const host = SERVICE_TITAN_HOST[tenantCode];
  if (!host || jobId == null || jobId === '') return '';
  return `https://${host}.eh.go.servicetitan.com/#/Job/Index/${encodeURIComponent(jobId)}`;
};
